import { render, staticRenderFns } from "./ChangeAnswerEffect.vue?vue&type=template&id=85bb550a&scoped=true&"
import script from "./ChangeAnswerEffect.vue?vue&type=script&lang=js&"
export * from "./ChangeAnswerEffect.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAnswerEffect.vue?vue&type=style&index=0&id=85bb550a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bb550a",
  null
  
)

export default component.exports